import React from "react";

import RandingStyle30 from "../../randing/RandingStyle30";

function Randing515({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle30
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      videoSrc="https://d1k8m48tkgq306.cloudfront.net/images/511/2_new.mp4"
      stepImageBasePath="https://d1k8m48tkgq306.cloudfront.net/images/511"
      companyName="검단뉴욕치과의원"
      privacyCompanyName="검단뉴욕치과의원"
      legacyMarketing={true}
      hideFooter={true}
    />
  );
}

export default Randing515;
